import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function CreaEquipoDireccionamiento({ idSolicitud, onCreated }) {
  const [modalIsOpen, setIsOpen] = useState(false);

  const [nombre, setNombre] = useState("");
  const [area, setArea] = useState("");
  const [cargo, setCargo] = useState("");
  const [lider, setLider] = useState("");
  const [antiguedad, setAntiguedad] = useState("");

  const postData = async (e) => {
    e.preventDefault();

    try {
      await axios({
        method: "post",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: "https://suadesarrollo.azurewebsites.net/api/CreaEquipoDireccionamiento",
        data: {
          nombre,
          area,
          cargo,
          lider,
          antiguedad,
          SolicitudId: idSolicitud,
        },
      });

      alert("Registro creado con éxito");

      // 🔄 actualizar lista padre
      onCreated && onCreated();

      // 🔒 cerrar modal y limpiar
      setIsOpen(false);
      setNombre("");
      setArea("");
      setCargo("");
      setLider("");
      setAntiguedad("");
    } catch (error) {
      console.error(error);
      alert("Error al crear registro");
    }
  };

  return (
    <>
      <button className="btn btn-primary" onClick={() => setIsOpen(true)}>
        Nuevo
      </button>

      <ReactModal isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)}>
        <br></br>
        <br></br>
        <h5>Crear Equipo Direccionamiento</h5>

        <form onSubmit={postData}>
          <input
            className="form-control mb-2"
            placeholder="Nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
          />

          <input
            className="form-control mb-2"
            placeholder="Área"
            value={area}
            onChange={(e) => setArea(e.target.value)}
          />

          <input
            className="form-control mb-2"
            placeholder="Cargo"
            value={cargo}
            onChange={(e) => setCargo(e.target.value)}
          />

          <select
            className="form-control mb-3"
            value={lider}
            onChange={(e) => setLider(e.target.value)}
          >
            <option value="">¿Es líder?</option>
            <option value="Si">Sí</option>
            <option value="No">No</option>
          </select>
          <input
            className="form-control mb-2"
            placeholder="Años de antiguedad"
            value={antiguedad}
            onChange={(e) => setAntiguedad(e.target.value)}
          />

          <button className="btn btn-primary w-100">Guardar</button>
        </form>
      </ReactModal>
    </>
  );
}

export default CreaEquipoDireccionamiento;
